var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "booking-progress_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeWidth: 2,
    d: "M28.387 36.194c0-2.565 2.235-4.646 4.99-4.646h6.242c2.755 0 4.99 2.083 4.99 4.646 0 2.565-2.235 4.645-4.99 4.645h-6.242c-2.755 0-4.99-2.083-4.99-4.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202E4A",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M33.032 37.355a1.161 1.161 0 010-2.323h2.903a1.162 1.162 0 110 2.322h-2.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#booking-progress_svg__a)",
    stroke: "#202E4A",
    strokeWidth: 2,
    d: "M18 1A16.943 16.943 0 005.98 5.98C2.902 9.055 1 13.305 1 18s1.903 8.944 4.98 12.02A16.935 16.935 0 0018 35c1.485 0 2.925-.19 4.297-.548a7.936 7.936 0 01-1.232-4.258c0-2.2.891-4.192 2.333-5.634a7.939 7.939 0 015.633-2.334l5.438.01C34.816 20.88 35 19.461 35 18c0-4.694-1.903-8.944-4.98-12.02A16.935 16.935 0 0018 1z",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.387 23.42h-5.806v-9.292a1.161 1.161 0 00-2.322 0V24.58c0 .641.519 1.16 1.16 1.16h6.968a1.16 1.16 0 10.001-2.322z"
  }))));
}
export default SvgBookingProgress;